import type { JSX } from 'react'

// TODO: replace with new icons from Figma
export const AppleSolidIcon = (): JSX.Element => (
  <use href='#appleSolidIcon' height='100%' width='100%' />
)
